<div class="vvvo-inline-select">
    <button
        *ngIf="!kunde"
        mat-stroked-button
        color="accent"
        class="vvvo-inline-select__btn"
        type="button"
        (click)="openToolbarVVVOAuswaehlenDialog()"
    >
        <mat-icon>store</mat-icon>
        <span>Betrieb ausw&auml;hlen</span>
    </button>

    <div *ngIf="kunde" class="vvvo-inline-select__selected">
        <button
            mat-stroked-button
            color="accent"
            class="vvvo-inline-select__btn vvvo-inline-select__btn--selected"
            type="button"
            (click)="openToolbarVVVOAuswaehlenDialog()"
        >
            <mat-icon>store</mat-icon>
            <span class="vvvo-inline-select__name">
                {{ kunde?.bezeichnung_final }} {{ kunde?.zusatz_final }}
            </span>
        </button>
        <button
            mat-icon-button
            color="accent"
            type="button"
            aria-label="Betrieb abwählen"
            (click)="betriebAbwaehlen()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
